import { render } from "./PlayoutDashboardV2.vue?vue&type=template&id=4b67bab5"
import script from "./PlayoutDashboardV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutDashboardV2.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TVPlayoutDash/PlayoutDashboardV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b67bab5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b67bab5', __exports__)) {
    api.reload('4b67bab5', __exports__)
  }
  
  module.hot.accept("./PlayoutDashboardV2.vue?vue&type=template&id=4b67bab5", () => {
    api.rerender('4b67bab5', render)
  })

}


export default __exports__